export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_DOCUID = 'AUTH_DOCUID'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const FULL_LOGOUT = 'FULL_LOGOUT'

